// The tabs of Meetings. Split out of MeetingsPage.tsx (performance-closure, plan §10.2) so the route
// validates `?tab=` without loading the page (availability, bookings, insights) up front.
export const MEETING_TABS = [
  'meetings',
  'recordings',
  'types',
  'availability',
  'insights',
  'routing',
] as const;
export type MeetingTab = (typeof MEETING_TABS)[number];
